<template>
  <aside class="aside-box hidden-md-and-down">
    <div class="aside">
      <VisitorCard />
      <HotTagsCard />
      <FriendsCard />
      <FinancialSupportCard />
    </div>
  </aside>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import VisitorCard from '@/components/VisitorCard.vue'
import HotTagsCard from '@/components/HotTagsCard.vue'
// const HotTagsCard = defineAsyncComponent(()=>import('@/components/HotTagsCard.vue'))
import FriendsCard from './FriendsCard.vue'
import FinancialSupportCard from '@/components/FinancialSupportCard.vue'

export default defineComponent({
  components: {
    VisitorCard,
    FinancialSupportCard,
    FriendsCard,
    HotTagsCard,
  },
  setup() {
    return {}
  },
})
</script>


<style lang="scss" scoped>
.aside-box {
  //   border: 1px solid green;
  .aside {
    padding-left: 30px;
  }
}
</style>